export default __webpack_public_path__ + "static/media/play.a3383a88.svg";